var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jobs"},[_c('h1',[_vm._v("This is a jobs advertisement page")]),_c('ul',_vm._l((_vm.jobs),function(job){return _c('li',{key:job.id},[_vm._v(_vm._s(job.title))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }